const enginePower = [
  { value: -1,  label: "Izaberi kubikažu motora"},
  { value: 1.0,  label: "1.0"},
  { value: 1.1,  label: "1.1"},
  { value: 1.2,  label: "1.2"},
  { value: 1.3,  label: "1.3"},
  { value: 1.4,  label: "1.4"},
  { value: 1.5,  label: "1.5"},
  { value: 1.6,  label: "1.6"},
  { value: 1.7,  label: "1.7"},
  { value: 1.8,  label: "1.8"},
  { value: 1.9,  label: "1.9"},
  { value: 2.0,  label: "2.0"},
  { value: 2.1,  label: "2.1"},
  { value: 2.2,  label: "2.2"},
  { value: 2.3,  label: "2.3"},
  { value: 2.4,  label: "2.4"},
  { value: 2.5,  label: "2.5"},
  { value: 2.6,  label: "2.6"},
  { value: 2.7,  label: "2.7"},
  { value: 2.8,  label: "2.8"},
  { value: 2.9,  label: "2.9"},
  { value: 3.0,  label: "3.0"},
  { value: 3.1,  label: "3.1"},
  { value: 3.2,  label: "3.2"},
  { value: 3.3,  label: "3.3"},
  { value: 3.4,  label: "3.4"},
  { value: 3.5,  label: "3.5"},
  { value: 3.6,  label: "3.6"},
];

const fuelTypes = [ 
  {value: -1, label: "Izaberi tip motora"},
  {value: 1, label: "TDI"},
  {value: 2, label: "TSI"},
  {value: 3, label: "TFSI"},
  {value: 4, label: "FSI"},
  {value: 5, label: "BiTDI"},
];

const engineTypes = [
  { value: -1, label: "Izaberi oznaku"},
  { value: 1, label: "AXZ"},
  { value: 2, label: "BWS"},
  { value: 3, label: "CAG"},
  { value: 4, label: "CAX"},
  { value: 5, label: "CAY"},
  { value: 6, label: "CBA"},
  { value: 7, label: "CBB"},
  { value: 8, label: "CBD"},
  { value: 9, label: "CCW"},
  { value: 10, label: "CDA"},
  { value: 11, label: "CDV"},
  { value: 12, label: "CEG"},
  { value: 13, label: "CFF"},
  { value: 14, label: "CFG"},
  { value: 15, label: "CFH"},
  { value: 16, label: "CFJ"},
  { value: 17, label: "CFW"},
  { value: 18, label: "CGK"},
  { value: 19, label: "CGL"},
  { value: 20, label: "CKF"},
  { value: 21, label: "CLB"},
  { value: 22, label: "CLH"},
  { value: 23, label: "CRB"},
  { value: 24, label: "CRK"},
  { value: 25, label: "CRL"},
  { value: 26, label: "CXX"},
  { value: 27, label: "DBK"},
  { value: 28, label: "DCY"},
  { value: 29, label: "DET"},
  { value: 30, label: "DEU"},
  { value: 31, label: "DFS"},  
  { value: 32, label: "CBZ"},
  { value: 33, label: "CCZ"},
  { value: 34, label: "CDN"},
  { value: 35, label: "CLAB"},
  { value: 36, label: "DDY"},
];

const transmissions = [
  { label: "Izaberi transmisiju", value: -1 },
  { label: "Automatik", value: 1 },
  { label: "Manuelni", value: 2 }
];
const bodyTypeData = [
  { value: -1, label: "Izaberi tip" },
  { value: 1, label: "Ostalo" },
  { value: 2, label: "Limuzina" },
  { value: 3, label: "Malo auto" },
  { value: 4, label: "Karavan" },
  { value: 5, label: "Monovolumen" },
  { value: 6, label: "Kombi" },
  { value: 7, label: "Terenac" },
  { value: 8, label: "SUV" },
  { value: 9, label: "Kabriolet" },
  { value: 10, label: "Sportski/kupe" },
  { value: 11, label: "Off Road" },
  { value: 12, label: "Caddy" },
  { value: 13, label: "Pick up" },
  { value: 14, label: "Oldtimer" }    
];

const paymentStatus = [
  { label: "Plaćeno?", value: -1 },
  { label: "Ne", value: 0 },
  { label: "Da", value: 1 }
];

const partStatusData = [
  { label: "Dostupno", badgeType: "success", value: 1}, 
  { label: "Nedostupno", badgeType: "danger", value: 2},
  { label: "Na čekanju", badgeType: "warning", value: 3},
  { label: "Prodano", badgeType: "primary", value: 4}
];
const categories = [
  {
    label: "Izaberi kategoriju",
    value: -1
  },
  {
    label: "ABS sistemi",
    value: 1473
  },
  {
    label: "Aditivi",
    value: 2607
  },
  {
    label: "Airbagovi",
    value: 1443
  },
  {
    label: "Akumulatori",
    value: 1446
  },
  {
    label: "Alarmi",
    value: 1613
  },
  {
    label: "Alat i pribor",
    value: 1615
  },
  {
    label: "Alternatori",
    value: 1768
  },
  {
    label: "Amortizeri i opruge",
    value: 1462
  },
  {
    label: "Anlaseri",
    value: 1438
  },
  {
    label: "Antene",
    value: 2435
  },
  {
    label: "Antifrizi i permanti",
    value: 2606
  },
  {
    label: "Auto kamere",
    value: 2350
  },
  {
    label: "Auto klime",
    value: 1524
  },
  {
    label: "Autodijagnostika",
    value: 1603
  },
  {
    label: "Autofolije",
    value: 2587
  },
  {
    label: "Autokozmetika",
    value: 942
  },
  {
    label: "Automobili u dijelovima",
    value: 1523
  },
  {
    label: "Autopresvlake",
    value: 2028
  },
  {
    label: "Baglame vrata",
    value: 2483
  },
  {
    label: "Balans štange",
    value: 2439
  },
  {
    label: "Balasti",
    value: 2501
  },
  {
    label: "Bass/Woofer i kutije",
    value: 1567
  },
  {
    label: "Birači brzina",
    value: 2472
  },
  {
    label: "Blatobrani",
    value: 1456
  },
  {
    label: "Blende/okviri za radio",
    value: 2580
  },
  {
    label: "Board kompjuteri",
    value: 1790
  },
  {
    label: "Bobine",
    value: 1442
  },
  {
    label: "Branici/Karambolke i spojleri",
    value: 944
  },
  {
    label: "Brave i ključevi",
    value: 1614
  },
  {
    label: "Bregaste osovine",
    value: 1811
  },
  {
    label: "Brisači",
    value: 1440
  },
  {
    label: "CD/DVD/MC/Radio player",
    value: 1565
  },
  {
    label: "Cerade",
    value: 2462
  },
  {
    label: "Čepovi za felge",
    value: 2034
  },
  {
    label: "Cijelo ozvučenje",
    value: 946
  },
  {
    label: "Crijeva",
    value: 2320
  },
  {
    label: "Dekla motora",
    value: 2485
  },
  {
    label: "Diferencijali",
    value: 2322
  },
  {
    label: "Dihtung",
    value: 1789
  },
  {
    label: "Diskovi/Pločice",
    value: 1472
  },
  {
    label: "Display/Ekran",
    value: 2451
  },
  {
    label: "Distanceri",
    value: 2452
  },
  {
    label: "Dizalice",
    value: 1486
  },
  {
    label: "Dizne",
    value: 1478
  },
  {
    label: "Doboši točka/kočioni",
    value: 2142
  },
  {
    label: "Duple komande",
    value: 2124
  },
  {
    label: "ECU jedinice/Procesori/Kompjuteri",
    value: 2491
  },
  {
    label: "Elektronika i Akustika",
    value: 1080
  },
  {
    label: "Equalizer",
    value: 1606
  },
  {
    label: "FM transmiteri",
    value: 2401
  },
  {
    label: "Farovi i Štopke",
    value: 939
  },
  {
    label: "Felge",
    value: 937
  },
  {
    label: "Felge s gumama (Točkovi komplet)",
    value: 1616
  },
  {
    label: "Filteri",
    value: 1434
  },
  {
    label: "Glave motora",
    value: 2139
  },
  {
    label: "Glavčine",
    value: 1624
  },
  {
    label: "Graničnici vrata",
    value: 2516
  },
  {
    label: "Grijači",
    value: 1749
  },
  {
    label: "Gume",
    value: 940
  },
  {
    label: "Haube",
    value: 1457
  },
  {
    label: "Hladnjaci",
    value: 1469
  },
  {
    label: "Instrument table",
    value: 1451
  },
  {
    label: "Izduvni sistemi",
    value: 945
  },
  {
    label: "Kablovi i konektori",
    value: 1599
  },
  {
    label: "Kapice",
    value: 1476
  },
  {
    label: "Karburatori",
    value: 1444
  },
  {
    label: "Kardan",
    value: 1621
  },
  {
    label: "Karteri",
    value: 1766
  },
  {
    label: "Katalizatori",
    value: 1436
  },
  {
    label: "Kederi",
    value: 2393
  },
  {
    label: "Kilometar satovi",
    value: 1788
  },
  {
    label: "Kinetički zglobovi",
    value: 2105
  },
  {
    label: "Klipovi",
    value: 2138
  },
  {
    label: "Kompresori",
    value: 1622
  },
  {
    label: "Kondenzatori",
    value: 1604
  },
  {
    label: "Kopče/Žabice/Spojke",
    value: 2445
  },
  {
    label: "Kočioni cilindri",
    value: 1487
  },
  {
    label: "Kožice mjenjača",
    value: 2353
  },
  {
    label: "Krajnice",
    value: 2107
  },
  {
    label: "Kuke",
    value: 1458
  },
  {
    label: "Kućišta osigurača i osigurači",
    value: 2523
  },
  {
    label: "Kvačila",
    value: 1474
  },
  {
    label: "Lafete",
    value: 1618
  },
  {
    label: "Lajsne i pragovi",
    value: 1522
  },
  {
    label: "Lamele",
    value: 1452
  },
  {
    label: "Lanci za snijeg",
    value: 1812
  },
  {
    label: "Letve volana",
    value: 1471
  },
  {
    label: "Ležajevi",
    value: 1435
  },
  {
    label: "Limarija",
    value: 1079
  },
  {
    label: "Maglenke",
    value: 2015
  },
  {
    label: "Makaze i držači haube",
    value: 2463
  },
  {
    label: "Manžetne",
    value: 2571
  },
  {
    label: "Maske",
    value: 1439
  },
  {
    label: "Metlice brisača",
    value: 2012
  },
  {
    label: "Mjenjači",
    value: 1433
  },
  {
    label: "Mjerači i šipke ulja",
    value: 2603
  },
  {
    label: "Moduli airbegova",
    value: 2644
  },
  {
    label: "Motori",
    value: 1061
  },
  {
    label: "Motori šibera",
    value: 2589
  },
  {
    label: "Motorići i klapne grijanja",
    value: 2441
  },
  {
    label: "Naljepnice/Stikeri",
    value: 2455
  },
  {
    label: "Naslonjači",
    value: 1460
  },
  {
    label: "Navigacija/GPS",
    value: 938
  },
  {
    label: "Nosači alternatora",
    value: 2489
  },
  {
    label: "Nosači auspuha",
    value: 2624
  },
  {
    label: "Nosači blatobrana",
    value: 2623
  },
  {
    label: "Nosači farova",
    value: 2488
  },
  {
    label: "Nosači hladnjaka",
    value: 2569
  },
  {
    label: "Nosači i koferi",
    value: 1449
  },
  {
    label: "Nosači i plastike akumulatora",
    value: 2520
  },
  {
    label: "Nosači motora/mjenjača",
    value: 2128
  },
  {
    label: "Nosači osovina",
    value: 2576
  },
  {
    label: "Nosači ventilatora",
    value: 2570
  },
  {
    label: "Nosači/Grede branika",
    value: 2459
  },
  {
    label: "Okviri za tablice",
    value: 2125
  },
  {
    label: "Osovine/Mostovi",
    value: 1490
  },
  {
    label: "Pakne",
    value: 1441
  },
  {
    label: "Papučice",
    value: 2425
  },
  {
    label: "Patosnice/Podmetači",
    value: 1461
  },
  {
    label: "Pepeljare/Pepelnice",
    value: 2473
  },
  {
    label: "Plastika",
    value: 1623
  },
  {
    label: "Plinski uređaji",
    value: 1759
  },
  {
    label: "Podizači stakala",
    value: 2094
  },
  {
    label: "Pojačala",
    value: 1570
  },
  {
    label: "Poklopci i čepovi rezervoara",
    value: 2517
  },
  {
    label: "Poklopci/Zaštite motora",
    value: 2456
  },
  {
    label: "Posude za tečnosti",
    value: 2152
  },
  {
    label: "Prekvalueači",
    value: 1450
  },
  {
    label: "Protokomjeri zraka",
    value: 1475
  },
  {
    label: "Pumpe",
    value: 1448
  },
  {
    label: "Radilice",
    value: 2141
  },
  {
    label: "Rampe goriva",
    value: 2437
  },
  {
    label: "Ratkape",
    value: 1454
  },
  {
    label: "Razvodnici paljenja",
    value: 2477
  },
  {
    label: "Reduktori",
    value: 2157
  },
  {
    label: "Releji",
    value: 2328
  },
  {
    label: "Remenovi",
    value: 1760
  },
  {
    label: "Retrovizori",
    value: 943
  },
  {
    label: "Rezervni točkovi",
    value: 2661
  },
  {
    label: "Rezervoari",
    value: 1479
  },
  {
    label: "Roletne/daske gepeka",
    value: 2453
  },
  {
    label: "Rotacije",
    value: 2605
  },
  {
    label: "Ručice mjenjača",
    value: 2062
  },
  {
    label: "Ručne kočnice",
    value: 2450
  },
  {
    label: "Sajle",
    value: 2144
  },
  {
    label: "Senzori",
    value: 1470
  },
  {
    label: "Sigurnosni pojasevi",
    value: 2458
  },
  {
    label: "Sijalice",
    value: 1453
  },
  {
    label: "Sirene i tasteri",
    value: 2549
  },
  {
    label: "Sjedišta",
    value: 941
  },
  {
    label: "Skretnice",
    value: 1605
  },
  {
    label: "Snorkel",
    value: 2629
  },
  {
    label: "Stabilizatori",
    value: 2321
  },
  {
    label: "Svjetla tablica",
    value: 2558
  },
  {
    label: "Svjećice",
    value: 1726
  },
  {
    label: "Tapacirung",
    value: 1619
  },
  {
    label: "Termostati",
    value: 2069
  },
  {
    label: "Tuning",
    value: 948
  },
  {
    label: "Turbine",
    value: 1447
  },
  {
    label: "Ulja",
    value: 1455
  },
  {
    label: "Unutrašnje osvjetljenje",
    value: 2557
  },
  {
    label: "Unutrašnji izgled",
    value: 1463
  },
  {
    label: "Usisne grane",
    value: 2106
  },
  {
    label: "Vakum boca",
    value: 2639
  },
  {
    label: "Vakumi turbina",
    value: 2598
  },
  {
    label: "Vandleri",
    value: 2583
  },
  {
    label: "Vanjski izgled",
    value: 1464
  },
  {
    label: "Ventilatori",
    value: 1480
  },
  {
    label: "Ventili",
    value: 1477
  },
  {
    label: "Vitla",
    value: 2530
  },
  {
    label: "Volani",
    value: 1445
  },
  {
    label: "Vrata",
    value: 1459
  },
  {
    label: "Zaštite (sigurnosne)",
    value: 1612
  },
  {
    label: "Zaštite za haubu",
    value: 1751
  },
  {
    label: "Znakovi",
    value: 1617
  },
  {
    label: "Zvučnici",
    value: 1566
  },
  {
    label: "Šajbe i prozori",
    value: 1034
  },
  {
    label: "Šarafi za felge",
    value: 2095
  },
  {
    label: "Školjke",
    value: 1504
  },
  {
    label: "Španeri/Remenice",
    value: 2101
  },
  {
    label: "Šprice, brisači i motorići farova",
    value: 2518
  },
  {
    label: "Špule volana",
    value: 2460
  },
  {
    label: "Žmigavci",
    value: 1541
  },
  {
    label: "Ostalo",
    value: 947
  }
];

const manufacturers = [
  { value: -1, label: "Izaberi proizvođača" },
  { value: 1, label: "Audi" },
  { value: 2, label: "Škoda" },
  { value: 3, label: "Volkswagen" },
  { value: 4, label: "Seat" }
];

const models = [
  { value: -1, parentValue: -1, label: "Izaberi model"},
  { value: 30, parentValue: 1, label: "A1"}, 
  { value: 31, parentValue: 1, label: "A2"}, 
  { value: 32, parentValue: 1, label: "A3"}, 
  { value: 33, parentValue: 1, label: "A3 8P"}, 
  { value: 34, parentValue: 1, label: "A3 8V"}, 
  { value: 35, parentValue: 1, label: "A3 Allstreet"}, 
  { value: 36, parentValue: 1, label: "A4"}, 
  { value: 37, parentValue: 1, label: "A4 B8"}, 
  { value: 38, parentValue: 1, label: "A4 B8.5"}, 
  { value: 39, parentValue: 1, label: "A4 B9"}, 
  { value: 40, parentValue: 1, label: "A4 Allroad"}, 
  { value: 41, parentValue: 1, label: "A5"}, 
  { value: 42, parentValue: 1, label: "A6"}, 
  { value: 43, parentValue: 1, label: "A6 Allroad"}, 
  { value: 44, parentValue: 1, label: "A7"}, 
  { value: 45, parentValue: 1, label: "A8"}, 
  { value: 46, parentValue: 1, label: "Cabriolet"}, 
  { value: 47, parentValue: 1, label: "Coupé"}, 
  { value: 48, parentValue: 1, label: "e-tron"}, 
  { value: 49, parentValue: 1, label: "e-tron GT"}, 
  { value: 50, parentValue: 1, label: "Q4 e-tron"}, 
  { value: 51, parentValue: 1, label: "Q8 e-tron"}, 
  { value: 52, parentValue: 1, label: "Q1"}, 
  { value: 53, parentValue: 1, label: "Q2"}, 
  { value: 54, parentValue: 1, label: "Q3"}, 
  { value: 55, parentValue: 1, label: "Q5"}, 
  { value: 56, parentValue: 1, label: "Q7"}, 
  { value: 57, parentValue: 1, label: "Q8"}, 
  { value: 58, parentValue: 1, label: "QUATTRO"}, 
  { value: 59, parentValue: 1, label: "R8"}, 
  { value: 60, parentValue: 1, label: "RS2"}, 
  { value: 61, parentValue: 1, label: "RS3"}, 
  { value: 62, parentValue: 1, label: "RS4"}, 
  { value: 63, parentValue: 1, label: "RS5"}, 
  { value: 64, parentValue: 1, label: "RS6"}, 
  { value: 65, parentValue: 1, label: "RS7"}, 
  { value: 66, parentValue: 1, label: "RSQ3"}, 
  { value: 67, parentValue: 1, label: "RSQ8"}, 
  { value: 68, parentValue: 1, label: "S1"}, 
  { value: 69, parentValue: 1, label: "S2"}, 
  { value: 70, parentValue: 1, label: "S3"}, 
  { value: 71, parentValue: 1, label: "S4"}, 
  { value: 72, parentValue: 1, label: "S5"}, 
  { value: 73, parentValue: 1, label: "S6"}, 
  { value: 74, parentValue: 1, label: "S7"}, 
  { value: 75, parentValue: 1, label: "S8"}, 
  { value: 76, parentValue: 1, label: "SQ2"}, 
  { value: 77, parentValue: 1, label: "SQ5"}, 
  { value: 78, parentValue: 1, label: "SQ7"}, 
  { value: 79, parentValue: 1, label: "SQ8"}, 
  { value: 80, parentValue: 1, label: "TT"}, 
  { value: 81, parentValue: 1, label: "TT RS"}, 
  { value: 82, parentValue: 1, label: "TTS"}, 
  { value: 83, parentValue: 1, label: "V8"}, 
  { value: 84, parentValue: 1, label: "80"}, 
  { value: 85, parentValue: 1, label: "90"}, 
  { value: 86, parentValue: 1, label: "100"}, 
  { value: 87, parentValue: 1, label: "200"}, 
  { value: 88, parentValue: 1, label: "Drugi"}, 
  { value: 89, parentValue: 2, label: "105"}, 
  { value: 90, parentValue: 2, label: "120"}, 
  { value: 91, parentValue: 2, label: "130"}, 
  { value: 92, parentValue: 2, label: "135"}, 
  { value: 93, parentValue: 2, label: "Citigo"}, 
  { value: 94, parentValue: 2, label: "Enyaq"}, 
  { value: 95, parentValue: 2, label: "Enyaq Coupé"}, 
  { value: 96, parentValue: 2, label: "Fabia"}, 
  { value: 97, parentValue: 2, label: "Fabia RS"}, 
  { value: 98, parentValue: 2, label: "Favorit"}, 
  { value: 99, parentValue: 2, label: "Felicia"}, 
  { value: 100, parentValue: 2, label: "Forman"}, 
  { value: 101, parentValue: 2, label: "Kamiq"}, 
  { value: 102, parentValue: 2, label: "Karoq"}, 
  { value: 103, parentValue: 2, label: "Kodiaq"}, 
  { value: 104, parentValue: 2, label: "Octavia"}, 
  { value: 105, parentValue: 2, label: "Octavia A6"}, 
  { value: 106, parentValue: 2, label: "Octavia A7"}, 
  { value: 107, parentValue: 2, label: "Octavia A7.5"}, 
  { value: 108, parentValue: 2, label: "Octavia RS"}, 
  { value: 109, parentValue: 2, label: "Octavia Scout"}, 
  { value: 110, parentValue: 2, label: "Pick-up"}, 
  { value: 111, parentValue: 2, label: "Praktik"}, 
  { value: 112, parentValue: 2, label: "Rapid"}, 
  { value: 113, parentValue: 2, label: "Roomster"}, 
  { value: 114, parentValue: 2, label: "Scala"}, 
  { value: 115, parentValue: 2, label: "Spaceback"}, 
  { value: 116, parentValue: 2, label: "Superb"}, 
  { value: 117, parentValue: 2, label: "Yeti"}, 
  { value: 118, parentValue: 2, label: "Drugi"}, 
  { value: 119, parentValue: 3, label: "181"}, 
  { value: 120, parentValue: 3, label: "Amarok"}, 
  { value: 121, parentValue: 3, label: "Arteon"}, 
  { value: 122, parentValue: 3, label: "Atlas"}, 
  { value: 123, parentValue: 3, label: "Bora"}, 
  { value: 124, parentValue: 3, label: "Buba / Beetle"}, 
  { value: 125, parentValue: 3, label: "Buggy"}, 
  { value: 126, parentValue: 3, label: "Caddy"}, 
  { value: 127, parentValue: 3, label: "Corrado"}, 
  { value: 128, parentValue: 3, label: "Crafter"}, 
  { value: 129, parentValue: 3, label: "Eos"}, 
  { value: 130, parentValue: 3, label: "Fox"}, 
  { value: 131, parentValue: 3, label: "e-Golf"}, 
  { value: 132, parentValue: 3, label: "Golf 6"}, 
  { value: 133, parentValue: 3, label: "Golf 6 Plus"}, 
  { value: 134, parentValue: 3, label: "Golf 7"}, 
  { value: 135, parentValue: 3, label: "Golf 7.5"}, 
  { value: 136, parentValue: 3, label: "Golf Alltrack"}, 
  { value: 137, parentValue: 3, label: "Golf GTE"}, 
  { value: 138, parentValue: 3, label: "Golf Plus"}, 
  { value: 139, parentValue: 3, label: "Golf Sportsvan"}, 
  { value: 140, parentValue: 3, label: "ID.3"}, 
  { value: 141, parentValue: 3, label: "ID.3 GTX"}, 
  { value: 142, parentValue: 3, label: "ID.4"}, 
  { value: 143, parentValue: 3, label: "ID.5"}, 
  { value: 144, parentValue: 3, label: "ID.6"}, 
  { value: 145, parentValue: 3, label: "ID.7"}, 
  { value: 146, parentValue: 3, label: "ID.7 GTX Tourer"}, 
  { value: 147, parentValue: 3, label: "ID.Buzz"}, 
  { value: 148, parentValue: 3, label: "ID.Buzz Cargo"}, 
  { value: 149, parentValue: 3, label: "Iltis"}, 
  { value: 150, parentValue: 3, label: "Jetta"}, 
  { value: 151, parentValue: 3, label: "Karmann Ghia"}, 
  { value: 152, parentValue: 3, label: "LT"}, 
  { value: 153, parentValue: 3, label: "Lupo"}, 
  { value: 154, parentValue: 3, label: "Passat"}, 
  { value: 155, parentValue: 3, label: "Passat 6"}, 
  { value: 156, parentValue: 3, label: "Passat 7"}, 
  { value: 157, parentValue: 3, label: "Passat 8"}, 
  { value: 158, parentValue: 3, label: "Passat Alltrack"}, 
  { value: 159, parentValue: 3, label: "Passat CC"}, 
  { value: 160, parentValue: 3, label: "Phaeton"}, 
  { value: 161, parentValue: 3, label: "Polo"}, 
  { value: 162, parentValue: 3, label: "Polo Cross"}, 
  { value: 163, parentValue: 3, label: "Polo Plus"}, 
  { value: 164, parentValue: 3, label: "Routan"}, 
  { value: 165, parentValue: 3, label: "Santana"}, 
  { value: 166, parentValue: 3, label: "Scirocco"}, 
  { value: 167, parentValue: 3, label: "Sharan"}, 
  { value: 168, parentValue: 3, label: "T1"}, 
  { value: 169, parentValue: 3, label: "T2"}, 
  { value: 170, parentValue: 3, label: "T3 Caravelle"}, 
  { value: 171, parentValue: 3, label: "T3 Drugi"}, 
  { value: 172, parentValue: 3, label: "T3 Kombi"}, 
  { value: 173, parentValue: 3, label: "T3 Multivan"}, 
  { value: 174, parentValue: 3, label: "T4 Caravelle"}, 
  { value: 175, parentValue: 3, label: "T4 Drugi"}, 
  { value: 176, parentValue: 3, label: "T4 Kombi"}, 
  { value: 177, parentValue: 3, label: "T4 Multivan"}, 
  { value: 178, parentValue: 3, label: "T5 Caravelle"}, 
  { value: 179, parentValue: 3, label: "T5 Drugi"}, 
  { value: 180, parentValue: 3, label: "T5 Kombi"}, 
  { value: 181, parentValue: 3, label: "T5 Multivan"}, 
  { value: 182, parentValue: 3, label: "T5 Shuttle"}, 
  { value: 183, parentValue: 3, label: "T6 Caravelle"}, 
  { value: 184, parentValue: 3, label: "T6 Drugi"}, 
  { value: 185, parentValue: 3, label: "T6 Kombi"}, 
  { value: 186, parentValue: 3, label: "T6 Multivan"}, 
  { value: 187, parentValue: 3, label: "T6 Shuttle"}, 
  { value: 188, parentValue: 3, label: "T7 Multivan"}, 
  { value: 189, parentValue: 3, label: "Taigo"}, 
  { value: 190, parentValue: 3, label: "Taro"}, 
  { value: 191, parentValue: 3, label: "T-Cross"}, 
  { value: 192, parentValue: 3, label: "Tiguan"}, 
  { value: 193, parentValue: 3, label: "Tiguan Allspace"}, 
  { value: 194, parentValue: 3, label: "Touareg"}, 
  { value: 195, parentValue: 3, label: "Touran"}, 
  { value: 196, parentValue: 3, label: "T-Roc"}, 
  { value: 197, parentValue: 3, label: "T-Roc Cabriolet"}, 
  { value: 198, parentValue: 3, label: "Up!"}, 
  { value: 199, parentValue: 3, label: "Vento"}, 
  { value: 200, parentValue: 3, label: "XL1"}, 
  { value: 201, parentValue: 3, label: "Drugi"},
  { value: 202, parentValue: 4, label: "Alhambra" },
  { value: 203, parentValue: 4, label: "Altea" },
  { value: 204, parentValue: 4, label: "Altea XL" },
  { value: 205, parentValue: 4, label: "Arona" },
  { value: 206, parentValue: 4, label: "Arosa" },
  { value: 207, parentValue: 4, label: "Ateca" },
  { value: 208, parentValue: 4, label: "Cordoba" },
  { value: 209, parentValue: 4, label: "Exeo" },
  { value: 210, parentValue: 4, label: "Ibiza" },
  { value: 211, parentValue: 4, label: "Inca" },
  { value: 212, parentValue: 4, label: "Leon" },
  { value: 213, parentValue: 4, label: "Malaga" },
  { value: 214, parentValue: 4, label: "Marbella" },
  { value: 215, parentValue: 4, label: "Mii" },
  { value: 216, parentValue: 4, label: "Tarraco" },
  { value: 217, parentValue: 4, label: "Tarraco e-HYBRID" },
  { value: 218, parentValue: 4, label: "Terra" },
  { value: 219, parentValue: 4, label: "Toledo" },
  { value: 220, parentValue: 4, label: "Drugi" }
];

export {enginePower, transmissions, fuelTypes, engineTypes, manufacturers, models, partStatusData, paymentStatus, bodyTypeData, categories };